export default __webpack_public_path__ + "scripts/resource/3f9e4cd67b36b64ec83d2a2422f5f1ed.svg";